import { getDefaultOrganization } from '@upright/common/iam/organizations/common';
import { useGetOrganization, useMyOrganizationsQuery } from '@upright/ui/api/iam/organizations/hooks';
import { useIsTeam } from '@upright/ui/common/generic/hooks';
import { isNil } from 'lodash';

export type HomeViewFrameOutletContext = {
  company: { id: string; name: string } | null | undefined;
  isLoading: boolean;
  getOrganizationDataQuery: ReturnType<typeof useGetOrganization>;
};

export function useBuildHomeViewFrameOutletContext() {
  const isTeam = useIsTeam();
  const getOrganizationsQuery = useMyOrganizationsQuery();
  const organization = getDefaultOrganization(getOrganizationsQuery.data?.organizations, isTeam);
  const getOrganizationDataQuery = useGetOrganization(organization?.id);
  const company = getOrganizationDataQuery.data?.company;

  const isLoading = (() => {
    if (getOrganizationsQuery.isLoading) {
      return true;
    }
    if (getOrganizationsQuery.data?.organizations.length && isNil(organization)) {
      return true;
    }
    return false;
  })();

  const context: HomeViewFrameOutletContext = { company, isLoading, getOrganizationDataQuery };
  return context;
}
